import React from 'react';
import { useTranslation } from '../../contexts/TranslationContext';
import MagneticButton from './MagneticButton';

const mainLogo = '/images/sanatorio_logo_nombre-2x.png';
const secondaryLogo = '/images/sanatorio_log.png';

const Header: React.FC = () => {
  const { setLanguage } = useTranslation();

  return (
    <header className="bg-cream-organic/90 backdrop-blur-lg border-b border-earth-light/10 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-8 py-4 flex items-center justify-between gap-8">
        <div className="flex items-center gap-6">
          <img src={secondaryLogo} alt="Sanatorio Log" className="h-10 md:h-14 w-auto object-contain opacity-80" />
          <div className="h-8 w-px bg-earth-light/20 hidden md:block" />
          <img src={mainLogo} alt="Restaurante Sanatorio Logo" className="h-10 md:h-12 w-auto object-contain" />
        </div>

        <div className="flex items-center gap-3 bg-white/40 p-1.5 rounded-full border border-earth-light/10 shadow-sm">
          {[
            { id: 'es', flag: 'es', name: 'Español' },
            { id: 'en', flag: 'gb', name: 'English' },
            { id: 'fr', flag: 'fr', name: 'Français' },
            { id: 'pt', flag: 'pt', name: 'Português' },
          ].map((lang) => (
            <MagneticButton
              key={lang.id}
              onClick={() => setLanguage(lang.id as any)}
              className="w-8 h-8 rounded-full overflow-hidden border border-earth-light/10"
              scale={1.2}
            >
              <img src={`https://flagcdn.com/w40/${lang.flag}.png`} alt={lang.name} className="w-full h-full object-cover" />
            </MagneticButton>
          ))}
        </div>
      </div>
    </header>
  );
};

export default Header;
